import { Controller } from "@hotwired/stimulus"
import slugify  from 'slugify'
import { get, post, put, patch, destroy } from '@rails/request.js'

export default class extends Controller {
  static targets = [ "imagePicker", "progressBar", "form", "slug", "title", "tab", "tabContent", "submitEditing", "submitSaved", "currentFeatureImage" ]
  static classes = [ "tabActive" ]
  static values = { articleId: Number, currentTab: Number, editing: Boolean }

  connect() {
    this.editingValue = false
  }

  imagePickerTargetDisconnected() {
    if (this.uppy) {
      this.uppy.close()
    }
  }

  imagePickerTargetConnected() {
    this.startUppy()
  }

  async startUppy() {
    const Uppy = (await import('@uppy/core')).default
    const XHRUpload = (await import('@uppy/xhr-upload')).default
    const DragDrop = (await import('@uppy/drag-drop')).default
    const ProgressBar = (await import('@uppy/progress-bar')).default

    this.uppy = new Uppy({ autoProceed: true, restrictions: { maxNumberOfFiles: 1 } })
          .use(
            DragDrop, { target: this.imagePickerTarget }
          )
          .use(
            XHRUpload, { endpoint: '/upload/feature_images' }
          )
          .use(
            ProgressBar, { target: this.progressBarTarget, hideAfterFinish: false }
          )

    this.uppy.on('complete', (result) => {
      const filesAdded = result.successful.map((file) => file.response.body)

      this.addImage(filesAdded[0])
      this.uppy.reset()
    })
  }

  async addImage(image) {
    await post(`/admin/articles/${this.articleIdValue}/add-feature-image`, {
      body: {
        file: image
      },
      responseKind: 'turbo-stream'
    })
  }

  async removeImage(image_id) {
    await post(`/admin/articles/${this.articleIdValue}/remove-feature-image`, {
      responseKind: 'turbo-stream'
    })
  }

  editing() {
    if (!this.editingValue) {
      this.editingValue = true
    }
  }

  submitEnd(event) {
    this.editingValue = false
  }

  editingValueChanged() {
    if (this.editingValue) {
      this.submitEditingTarget.classList.remove('!hidden')
      this.submitSavedTarget.classList.add('!hidden')
    } else {
      this.submitEditingTarget.classList.add('!hidden')
      this.submitSavedTarget.classList.remove('!hidden')
    }
  }

  updateSlug() {
    this.slugTarget.value = slugify(this.titleTarget.value, { lower: true, strict: true })
  }

  switchInfoTab() {
    this.currentTabValue = 0
  }

  switchSeoTab() {
    this.currentTabValue = 1
  }

  switchImagesTab() {
    this.currentTabValue = 2
  }

  currentTabValueChanged() {
      this.tabTargets.forEach((element, index) => {
        if (index !== this.currentTabValue) {
          element.classList.remove(this.tabActiveClass)
        } else {
          element.classList.add(this.tabActiveClass)
        }
      })

      this.tabContentTargets.forEach((element, index) => {
        if (index !== this.currentTabValue) {
          element.classList.add('hidden')
        } else {
          element.classList.remove('hidden')
        }
      })
  }
}
